(() => {
  if(customElements.get('df-delivery-truck'))return;
  class Truck extends HTMLElement {
    connectedCallback(){
      this.abort=new AbortController();const signal=this.abort.signal;
      this.vehicle=this.querySelector('.df-truck-vehicle');
      if(!this.vehicle)return;
      this.parentElement.classList.add('df-truck-host');
      this.bar=this.parentElement.querySelector('announcement-bar');
      this.button=this.querySelector('button');this.anims=[];this.visible=false;this.paused=false;
      this.reduce=matchMedia('(prefers-reduced-motion: reduce)');
      this.button.hidden=false;
      this.button.addEventListener('click',()=>{this.paused=!this.paused;this.sync();},{signal});
      this.vehicle.addEventListener('pointerdown',e=>this.grab(e),{signal,passive:true});
      window.addEventListener('pointermove',e=>this.drag(e),{signal,passive:true});
      window.addEventListener('pointerup',e=>this.drop(e),{signal,passive:true});
      window.addEventListener('pointercancel',e=>{if(this.hand?.id===e.pointerId)this.resetInteraction();},{signal,passive:true});
      window.addEventListener('blur',()=>this.resetInteraction(),{signal});
      window.addEventListener('scroll',()=>{if(this.hand)this.resetInteraction();},{signal,passive:true});
      this.reduce.addEventListener('change',()=>this.build(),{signal});
      document.addEventListener('visibilitychange',()=>this.sync(),{signal});
      this.bar?.addEventListener('carousel:change',()=>this.build(),{signal});
      this.bar?.addEventListener('carousel:settle',()=>this.build(),{signal});
      this.ro=new ResizeObserver(()=>this.build());this.ro.observe(this);
      this.io=new IntersectionObserver(e=>{this.visible=e[0].isIntersecting;this.sync();});this.io.observe(this);
      document.fonts?.ready.then(()=>{if(!signal.aborted)this.build();});
      this.build();
    }
    build(startX){
      this.cancelInteraction();
      this.anims?.forEach(a=>a.cancel());this.anims=[];
      const width=this.clientWidth;if(!width)return;
      let edge=width*.38,end=width*.62;
      const text=this.bar?.querySelector('.is-selected p');
      if(text){const range=document.createRange();range.selectNodeContents(text);const rect=range.getBoundingClientRect();if(rect.width){edge=rect.left-this.getBoundingClientRect().left;end=rect.right-this.getBoundingClientRect().left;}}
      this.style.setProperty('--truck-mask-left',Math.max(0,edge-5)+'px');
      this.style.setProperty('--truck-mask-right',Math.min(width,end+5)+'px');
      const truckWidth=this.vehicle.getBoundingClientRect().width;
      const stop=Math.max(0,Math.min(width-truckWidth-30,edge-truckWidth-10));
      this.stopX=stop;this.roadWidth=width;this.truckWidth=truckWidth;
      this.rightStop=Math.min(width-truckWidth,end+10);
      const start=Number.isFinite(startX)?startX:stop;
      this.vehicle.style.transform=`translateX(${start}px)`;
      if(this.reduce.matches){this.button.hidden=true;return;}
      this.button.hidden=false;
      const add=(el,frames,duration=8500)=>{const a=el.animate(frames,{duration,iterations:Infinity,easing:'linear'});a.pause();this.anims.push(a);};
      add(this.vehicle,[
        {transform:`translateX(${start}px)`,opacity:1,offset:0},
        {transform:`translateX(${width+60}px)`,opacity:1,offset:.40},
        {transform:`translateX(${width+60}px)`,opacity:0,offset:.41},
        {transform:'translateX(-65px)',opacity:0,offset:.44},
        {transform:'translateX(-65px)',opacity:1,offset:.45},
        {transform:`translateX(${stop+3}px)`,opacity:1,offset:.65},
        {transform:`translateX(${stop-4}px)`,opacity:1,offset:.67},
        {transform:`translateX(${stop}px)`,opacity:1,offset:.70},
        {transform:`translateX(${stop}px)`,opacity:1,offset:1}
      ]);
      add(this.querySelector('.df-truck-body'),[
        {transform:'translateY(0)'},{transform:'translateY(-1.2px) rotate(-1deg)'},{transform:'translateY(0)'},{transform:'translateY(-.5px)'},{transform:'translateY(0)'}
      ],420);
      add(this.querySelector('.df-truck-steam'),[
        {opacity:.1,transform:'translate(3px,2px) scale(.7)'},{opacity:.5,offset:.3},{opacity:0,transform:'translate(-7px,-3px) scale(1.25)'}
      ],900);
      add(this.querySelector('.df-truck-impact'),[
        {opacity:0,transform:'scale(.3)',offset:0},{opacity:0,offset:.645},
        {opacity:1,transform:'scale(1.3)',offset:.66},{opacity:0,transform:'scale(.8)',offset:.72},{opacity:0,offset:1}
      ]);
      this.sync();
    }
    sync(){
      const stop=this.paused||!this.visible||document.hidden||this.reduce.matches;
      this.anims?.forEach(a=>stop||this.hand||this.flight?a.pause():a.play());
      if(this.flight)stop?this.flight.pause():this.flight.play();
      if(this.spark)stop?this.spark.pause():this.spark.play();
      this.button.setAttribute('aria-pressed',String(this.paused));
      this.button.setAttribute('aria-label',this.paused?'Lieferwagen-Animation starten':'Lieferwagen-Animation pausieren');
      this.button.textContent=this.paused?'▷':'Ⅱ';
    }
    grab(e){
      if(!e.isPrimary||e.button!==0||this.paused||this.reduce.matches||!this.visible)return;
      const x=new DOMMatrixReadOnly(getComputedStyle(this.vehicle).transform).m41;
      this.cancelInteraction();this.anims.forEach(a=>a.pause());
      this.classList.add('is-interacting');
      this.vehicle.style.transform=`translateX(${x}px)`;
      // Cancel only the position animation; the original cycle is rebuilt after throwing.
      this.anims[0]?.cancel();
      this.hand={id:e.pointerId,start:e.clientX,y:e.clientY,last:e.clientX,time:performance.now(),x,v:0,dragging:false};
    }
    drag(e){
      const h=this.hand;if(!h||h.id!==e.pointerId)return;
      const dx=e.clientX-h.start,dy=e.clientY-h.y;
      if(!h.dragging){
        if(Math.abs(dy)>8&&Math.abs(dy)>Math.abs(dx)){this.resetInteraction();return;}
        if(Math.abs(dx)<6)return;
        h.dragging=true;
        try{this.vehicle.setPointerCapture(e.pointerId);}catch{}
        this.vehicle.classList.add('is-grabbed');
      }
      const now=performance.now(),dt=Math.max(8,now-h.time);
      h.v=Math.max(-1800,Math.min(1800,.35*h.v+.65*(e.clientX-h.last)/dt*1000));
      h.last=e.clientX;h.time=now;
      this.dragX=Math.max(-this.truckWidth,Math.min(this.roadWidth,h.x+dx));
      this.vehicle.style.transform=`translateX(${this.dragX}px)`;
    }
    drop(e){
      const h=this.hand;if(!h||h.id!==e.pointerId)return;
      const x=h.dragging?this.dragX:h.x;
      const velocity=performance.now()-h.time>100?0:h.v;
      this.vehicle.style.transform=`translateX(${x}px)`;
      this.cancelInteraction();
      this.launch(x,velocity);
    }
    launch(x,velocity){
      const plan=this.throwPlan(x,velocity);
      this.classList.add('is-interacting');
      this.flight=this.vehicle.animate(plan.frames,{duration:plan.duration,easing:'linear',fill:'forwards'});
      this.flight.onfinish=()=>{
        this.vehicle.style.transform=`translateX(${plan.target}px)`;
        this.flight.cancel();this.flight=null;
        this.impact(plan.target,plan.direction);
      };
      this.sync();
    }
    throwPlan(x,velocity){
      const frame=(x,offset,opacity=1)=>({transform:`translateX(${x}px)`,offset,opacity});
      const nearRight=Math.abs(x-this.rightStop)<Math.abs(x-this.stopX);
      if(Math.abs(velocity)<450){
        const target=nearRight?this.rightStop:this.stopX;
        return {target,direction:nearRight?-1:1,duration:Math.max(260,Math.min(900,Math.abs(x-target)*2)),frames:[{...frame(x,0),easing:'ease-out'},frame(target,1)]};
      }
      const right=velocity>0,exit=right?this.roadWidth+this.truckWidth:-this.truckWidth-5;
      const entry=right?-this.truckWidth-5:this.roadWidth+this.truckWidth;
      const target=right?this.stopX:this.rightStop;
      const d1=Math.abs(exit-x),d2=Math.abs(entry-target),split=Math.max(.1,Math.min(.85,d1/(d1+d2)));
      // One visible pass across the text, one edge wrap, collision at the approached edge.
      return {target,direction:right?1:-1,duration:Math.max(700,Math.min(3200,(d1+d2)/Math.max(450,Math.abs(velocity)) * 1300)),frames:[
        frame(x,0),frame(exit,split),frame(exit,split+.001,0),frame(entry,split+.002,0),frame(entry,split+.003),frame(target,1)
      ]};
    }
    impact(x,direction){
      const spark=this.querySelector('.df-truck-impact');
      spark.style.left=direction<0?'-8px':'auto';spark.style.right=direction<0?'auto':'-8px';
      this.spark=spark.animate([{opacity:0,transform:'scale(.4)'},{opacity:1,transform:'scale(1.3)',offset:.25},{opacity:0,transform:'scale(.8)'}],{duration:450});
      this.flight=this.vehicle.animate([
        {transform:`translateX(${x}px)`,offset:0},
        {transform:`translateX(${x-direction*7}px)`,offset:.2},
        {transform:`translateX(${x+direction*2}px)`,offset:.42},
        {transform:`translateX(${x}px)`,offset:.65},
        {transform:`translateX(${x}px)`,offset:1}
      ],{duration:700,easing:'ease-out',fill:'forwards'});
      this.flight.onfinish=()=>{
        this.vehicle.style.transform=`translateX(${x}px)`;
        this.flight.cancel();this.flight=null;
        spark.style.left='auto';spark.style.right='-8px';
        // Start the regular route exactly here, including after a rear-end collision.
        this.build(x);
      };
      this.sync();
    }
    park(){
      if(this.anims?.length){this.anims[0].currentTime=8500*.65;this.anims[3].currentTime=8500*.65;}
    }
    cancelInteraction(){
      if(this.hand){try{this.vehicle.releasePointerCapture(this.hand.id);}catch{}}
      this.hand=null;this.flight?.cancel();this.flight=null;
      this.spark?.cancel();this.spark=null;
      this.classList.remove('is-interacting');
      this.vehicle?.classList.remove('is-grabbed');
    }
    resetInteraction(){
      if(!this.hand&&!this.flight)return;
      const x=new DOMMatrixReadOnly(getComputedStyle(this.vehicle).transform).m41;
      this.build(x);
    }
    disconnectedCallback(){this.cancelInteraction();this.abort?.abort();this.ro?.disconnect();this.io?.disconnect();this.anims?.forEach(a=>a.cancel());}
  }
  customElements.define('df-delivery-truck',Truck);
})();
